import React, { useState, useEffect } from 'react';
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import AppSidebar from '../After_Login_common/AppSidebar';
import AppHeader from '../After_Login_common/AppHeader';

export default function PageWrapper({ children }) {
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    try {
      const roleData = localStorage.getItem('UserRole');
      if (roleData) {
        const role = window.atob(roleData);
        setUserRole(role);
      }
    } catch (error) {
      console.error('Error reading user role:', error);
    }
  }, []);

  const isAdmin = userRole === 'Admin';
  const isConsumer = userRole === 'consumer';

  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex flex-col min-h-screen w-full">
        {/* Full Width Header */}
        <AppHeader isAdmin={isAdmin} isConsumer={isConsumer} />
        
            {/* Sidebar + Main Content */}
            <div className="flex flex-1 min-w-0 overflow-hidden">
              <AppSidebar isAdmin={isAdmin} isConsumer={isConsumer} />
              <main className="flex-1 min-w-0 overflow-x-hidden p-4 sm:p-6 lg:p-8 bg-muted">
                {children}
              </main>
            </div>
      </div>
    </SidebarProvider>
  );
}
